import Vue from 'vue'
import Vuex from 'vuex'
import moreconfig from './tabRoute.js'
require('../util/Project/install')
Vue.use(Vuex)
export default new Vuex.Store({
	// strict: process.env.NODE_ENV !== 'production',
	state: {
		username: '',
		usertype:'',
		Stoken: '',
		userinfo: {},
		themColor: '',
		refreshStoken:'',
		serServlet:null,
		userRights:{},
		GUID:'',
		...moreconfig.state
	},
	getters: {
		dragV(state,{UserInfo}){
			if(UserInfo&&UserInfo.dragV){
				return UserInfo.dragV;
			}else return {};
		},
		GUID(state,{GUIDKey}){
			if(String(state.GUID)!='')
				return state.GUID;
			else return localStorage.getItem(GUIDKey);
		},
		IsLogin(state,{UserInfo}){
			return UserInfo._logIn;
		},
		getthemColor(state) {
			try {
				if (state.themColor != '')
					return state.themColor;
				else return localStorage.getItem('themColor')?localStorage.getItem('themColor'):'';
			} catch (e) {
				console.log(e)
				return {};
			}
		},
		//当前用户的实际取值 结合页面上获取的值和缓存的值
		UserInfo(state, {
			UserKey
		}) {
			try {
				//如果有保存的话就保存再session中否则 一个浏览器只能打开一个
				let userstr = localStorage.getItem(UserKey);
				console.log(userstr,UserKey)
				let user = {};
				if (userstr && String(userstr) != '') {
					console.log(window.BH.base.Localget(userstr))
					user = JSON.parse(window.BH.base.Localget(userstr));
				}
				console.log(state.usertype,user)
				let usertype=state.usertype
				if(state.usertype=='') usertype=sessionStorage.getItem('userType')||'';
				if(user.accountType){//之前数据结构的更新 下一个版本可以删除
					let tempuser={}
					tempuser[usertype]=user;
					user=tempuser;
				}
				if (JSON.stringify(state.userinfo) != '{}')
					return state.userinfo;
				else return user[usertype];
			} catch (e) {
				console.log(e)
				return {};
			}
		},
		UserKey() {
			if (window.BH)
				return window.BH.base.LocalSet('M10User');
			else return '';
		},
		CookieKey(){
			if (window.BH)
				return window.BH.base.LocalSet('M10Cookie');
			else return '';
		},
		refreshToken(){
			if (window.BH)
				return window.BH.base.LocalSet('M10refresh');
			else return '';
		},
		GUIDKey(){
			if (window.BH)
				return window.BH.base.LocalSet('MGUID');
			else return '';
		},
		UserName(state) {
			if (state.username != '')
				return state.username;
			else return window.BH.base.Localget(localStorage.getItem(window.BH.base.LocalSet('username')))
		},
		Stoken(state,{CookieKey}) {
			try {
				if(String(state.Stoken)=='') return window.BH.base.cookies.getCookie(CookieKey)||'';
				return state.Stoken; //localStorage.getItem('Stoken')
			} catch (e) {
				return e
			}
		},
		refreshStoken(state,{refreshToken}){
			try {
				if(String(state.refreshStoken)=='') return window.BH.base.cookies.getCookie(refreshToken)||'';
				return state.refreshStoken; //localStorage.getItem('Stoken')
			} catch (e) {
				return e
			}
		},
		UserRight(state){
			return state.userRights;
		},
		...moreconfig.getters
	},
	mutations: {
		setUserType(state,param){
			state.usertype=param;
		},
		setGUID(state){
			if(window.BH){
				let guid=window.BH.base.GUID();
				guid=`${guid}-${String(new Date().getTime())}`
				localStorage.setItem(this.getters.GUIDKey,guid);
				state.GUID=guid;
			}
		},
		setThemColor(state, param) {
			try {
				state.themColor = param;
				localStorage.setItem('themColor', param);
			} catch (e) {
				return e
			}
		},
		setStoken(state, param) {
			try {
				state.Stoken = param;
				//缓存在cookie中
				let key=this.getters.CookieKey;
				let _this=window.BH.base;
				if(_this.checkString(param))
					_this.cookies.setCookie(key,param,60*10);//10min
				else return false;
			} catch (e) {
				return e
			}
		},
		setrefreshStoken(state, param) {
			try {
				state.refreshStoken = param;
				//缓存在cookie中
				let key=this.getters.refreshToken;
				let _this=window.BH.base;
				if(_this.checkString(param))
					_this.cookies.setCookie(key,param,60*60*12);//一天的时间
				else return false;
			} catch (e) {
				return e
			}
		},
		setUserName(state, param) {
			try {
				state.username = param;
				localStorage.setItem(window.BH.base.LocalSet('username'), window.BH.base.LocalSet(param))
			} catch (e) {
				return e
			}
		},
		setUserInfo(state, param) {
			try {
				console.log(param)
				state.userinfo = param;
				let rootGetters = this.getters;
				let userinfo={};
				state.usertype=param.accountType;
				if(state.usertype=='') throw '用户类型无法获取'
				let userstr = localStorage.getItem(rootGetters.UserKey);
				if (userstr && String(userstr) != '') {
					userinfo = JSON.parse(window.BH.base.Localget(userstr));
					userinfo[state.usertype]=userinfo;
				}
				console.log(userinfo)
				localStorage.setItem(rootGetters.UserKey, window.BH.base.LocalSet(userinfo));
			} catch (e) {
				return e;
			}
		},
		appendUserInfo(state, param) {
			try {
				let rootGetters = this.getters;
				let userinfo = rootGetters.UserInfo;
				for (let i in param) {
					userinfo[i] = param[i];
				}
				state.userinfo=userinfo;
				let tempuser={};
				if(state.usertype=='') throw '用户类型无法获取';
				let userstr = localStorage.getItem(rootGetters.UserKey);
				if (userstr && String(userstr) != '') {
					tempuser = JSON.parse(window.BH.base.Localget(userstr));
					tempuser[state.usertype]=userinfo;
				}
				localStorage.setItem(rootGetters.UserKey, window.BH.base.LocalSet(tempuser));
			} catch (e) {
				return e;
			}
		},
		removeUser(state) {
			try {
				let rootGetters = this.getters;
				let userinfo = rootGetters.UserInfo;
				for (let i in ['username', 'pass', 'checked'])
					if (userinfo[i])
						delete userinfo[i];
				// localStorage.removeItem(rootGetters.UserKey);
			} catch (e) {
				return e;
			}
		},
		removeStoken(state){
			try {
				state.Stoken='';
				window.BH.base.cookies.removeCookie(this.getters.CookieKey)
			} catch (e) {
				return e;
			}
		},
		_logout(state){
			let rootGetters = this.getters;
			let userinfo = rootGetters.UserInfo;
			userinfo['_logIn'] = false;
			userinfo['_gysCheck'] = false;
			let tempuserinfo={};
			let userstr = localStorage.getItem(rootGetters.UserKey);
			if (userstr && String(userstr) != '') {
				tempuserinfo = JSON.parse(window.BH.base.Localget(userstr));
				console.log(tempuserinfo);
				tempuserinfo[state.usertype]=userinfo;
			}
			localStorage.setItem(rootGetters.UserKey, window.BH.base.LocalSet(tempuserinfo));
			if(state.serServlet!=null) state.serServlet.stop();
			this.commit('CloseAllTabs');
			this.commit('removeUser');
			this.commit('removeStoken');
		},
		logout(state,param) {
			try {
				var callback=param&&param.callback;
				var _this=this;
				let {UserInfo}=_this.getters;
				window.BH.base.http({
					url:'Web/logout',
					data:{
						FUser:state.username,
						FType:UserInfo.accountType
					},
					success:function(){
					}
				});
				//需要先退出
				callback&&callback();
				_this.commit('_logout');
				
				// localStorage.removeItem(rootGetters.UserKey);
			} catch (e) {
				return e;
			}
		},
		StopInterval(state){
			try {
				console.log('停止',state.serServle)
				if(state.serServlet!=null) state.serServlet.stop();
			} catch (e) {
				return e;
			}
		},
		setSerInvrtCheck(state){
			try {
				let getters=this.getters;
				// console.log(JSON.stringify(getters.UserInfo))
				if(JSON.stringify(getters.UserInfo)!=''){
					// console.log(getters.UserInfo._logIn)
					if(getters.UserInfo._logIn){
						if(state.serServle==null){
							state.serServlet=new window.BH.base.Interval(function(){
								// window.BH.base.http({
								// 	url: 'Task/checkVailRefresh'
								// })
								// console.log('check')
							},4000);
							// console.log(state.serServlet)
						}
						// state.serServlet.start();
					}
				}
				
			} catch (e) {
				return e;
			}
		},
		setUserRights(state,param){
			state.userRights=param;
		},
		...moreconfig.mutations
	},
	actions: {
		
	},
	modules: {}
})
